import axios from "axios";
import React, { useEffect, useState, useCallback, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { toast } from "react-toastify"
import { FaCamera, FaTimes } from "react-icons/fa";
import { Html5Qrcode, Html5QrcodeSupportedFormats } from "html5-qrcode";
import { API_BASE_URL } from "../../utils/CONSTANTS";
import { useSearchParams } from "react-router-dom";
import Header from "../../components/header";

const handleArrowKeyNavigation = (e) => {
  const row = parseInt(e.target.dataset.row);
  const col = parseInt(e.target.dataset.col);

  if (isNaN(row) || isNaN(col)) return;

  let nextInput = null;

  switch (e.key) {
    case "ArrowUp":
      nextInput = document.querySelector(`input[data-row="${row - 1}"][data-col="${col}"]`);
      break;
    case "ArrowDown":
      nextInput = document.querySelector(`input[data-row="${row + 1}"][data-col="${col}"]`);
      break;
    case "ArrowLeft":
      nextInput = document.querySelector(`input[data-row="${row}"][data-col="${col - 1}"]`);
      break;
    case "ArrowRight":
      nextInput = document.querySelector(`input[data-row="${row}"][data-col="${col + 1}"]`);
      break;
    default:
      return; // Exit if it's not an arrow key
  }

  if (nextInput) {
    nextInput.focus();
    e.preventDefault(); // Prevent default arrow key scroll behavior
  }
};

const Fdiform = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [mode, setMode] = useState("view");
  const navigate = useNavigate();
  const [maxreportno, setmaxreportno] = useState();
  const [cardnolist, setCardnoList] = useState([])
  const [showScanner, setShowScanner] = useState(false);
  const [isScanning, setIsScanning] = useState(false);
  const scannerRef = useRef(null);
  const scanHandledRef = useRef(false);
  const [formData, setFormData] = useState({
    consumerName: "",
    compname: "",
    drgno: "",
    partName: "",
    pono: "",
    lotno: "",
    qtyno: "",
    mtcreportno: "",
    batchno: "",
    rework: "",
    reject: "",
    cardno: "",
    date: new Date(Date.now()).toISOString().split("T")[0],
    table: [
      { id: 1, description: "Wire Dia", specifiedDimensions: "", observedDimensions: ["", "", "", "", ""], measuringInstruments: "", remarks: "" },
      { id: 2, description: "Inner Dia Small", specifiedDimensions: "", observedDimensions: ["", "", "", "", ""], measuringInstruments: "", remarks: "" },
      { id: 3, description: "Inner Dia Big", specifiedDimensions: "", observedDimensions: ["", "", "", "", ""], measuringInstruments: "", remarks: "" },
      { id: 4, description: "Free Length", specifiedDimensions: "", observedDimensions: ["", "", "", "", ""], measuringInstruments: "", remarks: "" },
      { id: 5, description: "Total Coils", specifiedDimensions: "", observedDimensions: ["", "", "", "", ""], measuringInstruments: "", remarks: "" },
      { id: 6, description: "Active Coils", specifiedDimensions: "", observedDimensions: ["", "", "", "", ""], measuringInstruments: "", remarks: "" },
      { id: 7, description: "Direction Coils", specifiedDimensions: "", observedDimensions: ["", "", "", "", ""], measuringInstruments: "", remarks: "" },
      { id: 8, description: "Finish", specifiedDimensions: "", observedDimensions: ["", "", "", "", ""], measuringInstruments: "", remarks: "" },
    ],
    dimension: "OK",
    material: "OK",
    mode: "fdi",
  });
  useEffect(() => {
    if (location.state) {
      const { mode, name } = location.state;
      console.log(location.state)
      setMode(mode);
      if (mode === "view" || mode === "update") {
        fetchData(name);
      }
      else {
        handleReport();
      }
    }

  }, []);
  useEffect(() => {
    if (searchParams) {
      const cardno = searchParams.get("cardno")
      const lotno = searchParams.get("lotno")
      const mode = searchParams.get("mode")
      if (mode === "view" || mode === "update") {
        setMode(mode)
        fetchDatabylot_cardno(cardno, lotno);
      }
      else {
        handleReport();
      }
    }
  }, [])
  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/order/getCardno`).then(v => {
      console.log(v.data.cardNos);
      const sorted = v.data.cardNos.sort((a, b) => b.cardNo.localeCompare(a.cardNo, undefined, { numeric: true }));
      setCardnoList(sorted);
    }, err => { })
  }, []);

  useEffect(() => {
    if (formData.table.every(row => row.observedDimensions.every(dim => dim.trim() !== ""))) {
      console.log("hi")
      setFormData(prevState => ({ ...prevState, mode: "topdi" }));
    }
  }, [formData.table]);

  const handleAdd = async () => {
    try {


      console.log(formData);

      const response = await axios.post(`${API_BASE_URL}/api/product/postfdi`, formData, {
        headers: {
          // Authorization: `Bearer ${token}`,
          'Content-Type': "application/json",
        }
      });

      if (response.status === 201) {
        toast("Product created");
        navigate("/fdimenu");
      }

    } catch (err) {
      console.log(err);
      toast(err.message);
      return;

    }
  }


  const contentRef = useRef();

  const captureAndGeneratePDF = () => {
    html2canvas(contentRef.current, {
      backgroundColor: '#ffffff', // Ensure background is fully white
      logging: false, // Disable logging
      useCORS: true, // Allow cross-origin resource sharing (for images and external content)
      scale: 2, // Increase scale for better quality (optional)
    }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4'); // Adjust paper size to A4 (210mm x 297mm)

      const pageWidth = pdf.internal.pageSize.width;
      const pageHeight = pdf.internal.pageSize.height;

      // Fit the canvas into the PDF page (adjust width and height)
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      // Maintain the aspect ratio and fit the image within the PDF
      let pdfWidth = pageWidth;
      let pdfHeight = (canvasHeight * pageWidth) / canvasWidth;

      if (pdfHeight > pageHeight) {
        // If the image is taller than the PDF, scale down
        pdfHeight = pageHeight;
        pdfWidth = (canvasWidth * pageHeight) / canvasHeight;
      }

      // Add the image to the PDF (adjusted to fit the page)
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

      // Save the PDF
      pdf.save('download.pdf');
    });
  };



  const handleUpdate = async () => {
    try {
      console.log(formData);
      const partName = formData.partName;
      console.log(formData);

      const response = await axios.put(`${API_BASE_URL}/api/product/putfdi/${partName}`, { formData: formData });
      const result = response.data;
      console.log(result);
      if (response.status === 200) {
        toast("Record Updated successfully");
        navigate("/fdimenu")
      }

    } catch (err) {
      console.log(err);

    }
  }

  const fetchData = async (partyName) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/product/getByproduct/${partyName}`);
      const result = response.data;
      console.log(result.isparty);
      setFormData(result.isparty);
    } catch (err) {
      console.log(err);

    }
  }
  const fetchDatabylot_cardno = async (cardno, lotno) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/product/getByproduct/${cardno}/${lotno}`);
      const result = response.data;
      console.log(result.isparty);
      setFormData(result.isparty);
    } catch (err) {
      console.log(err);

    }
  }

  const fetchDrawingByCardNo = async (cardNo) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/order/getDrgByCardNo/${cardNo}`);

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch drawing number");
      }
      const data = await response.json();

      return data.drgNo;
    } catch (error) {
      console.error("Error:", error.message);
      throw error;
    }
  };

  const parseOdId = (value) => {
    const raw = String(value ?? "").trim();
    if (!raw) return { od: "", id: "" };
    if (raw.includes("/")) {
      const [odPart, ...rest] = raw.split("/");
      return {
        od: String(odPart || "").trim(),
        id: rest.join("/").trim(),
      };
    }
    return { od: raw, id: "" };
  };

  const applyOrderSpecsToTable = (order, prevTable) => {
    const { od, id } = parseOdId(order?.osodId);
    const mapping = {
      "Wire Dia": order?.osd ?? "",
      "Inner Dia Small": id,
      "Inner Dia Big": od,
      "Free Length": order?.osl ?? "",
      "Total Coils": order?.ostColls ?? "",
      "Active Coils": order?.osactiveColls ?? "",
    };

    return prevTable.map((row) => {
      if (Object.prototype.hasOwnProperty.call(mapping, row.description)) {
        return {
          ...row,
          specifiedDimensions: String(mapping[row.description] ?? ""),
        };
      }
      return row;
    });
  };

  const fetchOrderSpecsByCardNo = async (cardNo) => {
    const response = await axios.get(
      `${API_BASE_URL}/api/order/getOrder/${encodeURIComponent(cardNo)}`
    );
    return response.data?.cardData || null;
  };

  const loadOrderDetailsForCard = async (cardNo) => {
    if (!cardNo) return;

    try {
      const [drgFromApi, order] = await Promise.all([
        fetchDrawingByCardNo(cardNo).catch(() => null),
        fetchOrderSpecsByCardNo(cardNo),
      ]);

      const orderDrg =
        order?.customDrgNo ||
        order?.drgNo ||
        drgFromApi ||
        "";

      setFormData((prevState) => ({
        ...prevState,
        drgno: orderDrg || prevState.drgno,
        // Part Name ← drawing no from order card
        partName: orderDrg || prevState.partName,
        table: order
          ? applyOrderSpecsToTable(order, prevState.table)
          : prevState.table,
      }));

      if (!order) {
        toast.warning("Order card details not found for specs");
      }
    } catch (error) {
      console.error("Error loading order details for FAI:", error);
      toast.error(
        error?.response?.data?.message || "Failed to load order card specs"
      );
    }
  };

  const handleChange = (name, value) => {
    console.log("name", name)
    console.log("value", value)
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === 'cardno' && value) {
      loadOrderDetailsForCard(value);
    }
  };

  const stopScanner = async () => {
    try {
      if (scannerRef.current) {
        try {
          await scannerRef.current.stop();
        } catch (_) {
          /* already stopped */
        }
        try {
          await scannerRef.current.clear();
        } catch (_) {
          /* ignore */
        }
        scannerRef.current = null;
      }
    } catch (err) {
      console.error("Error stopping scanner:", err);
      scannerRef.current = null;
    } finally {
      setIsScanning(false);
    }
  };

  const closeScanner = async () => {
    await stopScanner();
    setShowScanner(false);
    scanHandledRef.current = false;
  };

  const applyScannedCardNo = async (rawValue) => {
    if (scanHandledRef.current) return;
    scanHandledRef.current = true;

    const scanned = String(rawValue || "").trim();
    if (!scanned) {
      scanHandledRef.current = false;
      return;
    }

    const match = cardnolist.find(
      (item) => String(item.cardNo).trim() === scanned
    );
    const cardNo = match ? String(match.cardNo) : scanned;

    handleChange("cardno", cardNo);

    if (match) {
      toast.success(`Card No. ${cardNo} selected`);
    } else {
      toast.warning(
        `Scanned "${cardNo}" — not found in Card No. list. Verify the order card.`
      );
    }

    await closeScanner();
  };

  const openScanner = () => {
    if (mode === "view") {
      toast.info("Scanning is disabled in view mode");
      return;
    }
    scanHandledRef.current = false;
    setShowScanner(true);
  };

  useEffect(() => {
    if (!showScanner) return undefined;

    let cancelled = false;

    const startScanner = async () => {
      try {
        setIsScanning(true);
        const scanner = new Html5Qrcode("fdi-card-barcode-reader");
        scannerRef.current = scanner;

        await scanner.start(
          { facingMode: "environment" },
          {
            fps: 10,
            qrbox: { width: 280, height: 120 },
            aspectRatio: 1.5,
            formatsToSupport: [
              Html5QrcodeSupportedFormats.CODE_128,
              Html5QrcodeSupportedFormats.CODE_39,
              Html5QrcodeSupportedFormats.EAN_13,
              Html5QrcodeSupportedFormats.EAN_8,
              Html5QrcodeSupportedFormats.QR_CODE,
            ],
          },
          (decodedText) => {
            if (!cancelled) {
              applyScannedCardNo(decodedText);
            }
          },
          () => {}
        );
      } catch (err) {
        console.error("Unable to start camera scanner:", err);
        toast.error(
          err?.message?.includes("NotAllowedError") ||
            err?.name === "NotAllowedError"
            ? "Camera permission denied. Allow camera access and try again."
            : "Unable to start camera. Use HTTPS or localhost, and check camera permissions."
        );
        setShowScanner(false);
        setIsScanning(false);
      }
    };

    const timer = setTimeout(startScanner, 250);

    return () => {
      cancelled = true;
      clearTimeout(timer);
      stopScanner();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showScanner]);

  const handleTableChange = (id, field, value, sampleIndex) => {
    const updatedTable = formData.table.map(row => {
      if (row.id === id) {
        if (field === 'observedDimensions') {
          const updatedObservedDimensions = row.observedDimensions.map((sample, index) => {
            return index === sampleIndex ? value : sample;
          });
          return { ...row, observedDimensions: updatedObservedDimensions };
        }
        return { ...row, [field]: value };
      }
      return row;
    });

    setFormData({ ...formData, table: updatedTable });
  };





  const handleSubmit = async () => {
    try {
      if (mode === "update") {
        await handleUpdate();
      } else if (mode === "view") {
        await captureAndGeneratePDF();
      } else if (mode === "add") {
        await handleAdd();
      } else {
        await handleAdd();
      }
    } catch (err) {
      console.log(err);
    }
  };





  const handleReport = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/product/get-report-nos`);
      const result = response.data;
      setmaxreportno(result.maxvalue);
      setFormData((prev) => ({
        ...prev, reportno: result.maxvalue
      }))
    } catch (err) {
      console.log(err.message);

    }
  }


  return (
    <>
      <Header />

      <div className="md:max-w-4xl w-screen mx-auto p-6 border shadow-lg bg-white" ref={contentRef}>
        <div className="border border-black">
          <div className="flex md:flex-row flex-col border border-black">
            <div className="flex-1">
              <table className="w-full border-collapse border border-black">
                <thead>
                  <tr className="border border-black">
                    <th colSpan={3} className="text-center font-bold text-[0.9rem] p-2">
                      <div className="text-2xl ">PRECISION PRODUCTS</div>
                      <br />
                      3/8 Panchwati Compound, Janakpuri, Aligarh - 202001 <br />
                      Ph.: 9045161677
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {/* First Row Headers */}
                  <tr className="border border-black bg-gray-100">
                    <th className="border border-black p-2 h-16">Consumer Name</th>
                    <th className="border border-black p-2 h-16">Comp. Name</th>
                    <th className="border border-black p-2 h-16">Drg No</th>
                  </tr>

                  {/* First Input Row */}
                  <tr className="border border-black">
                    <td className="border border-black p-2 h-16">
                      <input
                        type="text"
                        className="w-full p-1 border border-gray-400 h-11"
                        placeholder="Enter Name"
                        value={formData.consumerName}
                        onChange={(e) => handleChange("consumerName", e.target.value)}
                        readOnly={mode == "view"}
                      />
                    </td>
                    <td className="border border-black p-2 h-16">
                      <input
                        type="text"
                        className="w-full p-1 border border-gray-400 h-11"
                        placeholder="Enter Comp. Name"
                        value={formData.compname}
                        onChange={(e) => handleChange("compname", e.target.value)}
                        readOnly={mode == "view"}

                      />
                    </td>
                    <td className="border border-black p-2 h-16">
                      <input
                        type="text"
                        className="w-full p-1 border border-gray-400 h-11"
                        placeholder="Enter Drg No"
                        value={formData.drgno}
                        onChange={(e) => handleChange('drgno', e.target.value)}
                        readOnly={true}

                      />
                    </td>
                  </tr>

                  {/* Second Row Headers */}
                  <tr className="border border-black bg-gray-100">
                    <th className="border border-black p-2 h-16">Part Name</th>
                    <th className="border border-black p-2 h-16">P.O. No</th>
                    <th className="border border-black p-2 h-16">Batch No</th>
                  </tr>

                  {/* Second Input Row */}
                  <tr className="border border-black">
                    <td className="border border-black p-2">
                      <input
                        type="text"
                        className="w-full p-1 border border-gray-400 h-11"
                        placeholder="Enter Part Name"
                        value={formData.partName}
                        onChange={(e) => handleChange("partName", e.target.value)}
                        readOnly={mode == "view"}

                      />
                    </td>
                    <td className="border border-black p-2">
                      <input
                        type="text"
                        className="w-full p-1 border border-gray-400 h-11"
                        placeholder="Enter P.O. No"
                        value={formData.pono}
                        onChange={(e) => handleChange("pono", e.target.value)}
                        readOnly={mode == "view"}

                      />
                    </td>
                    <td className="border border-black p-2">
                      <div className="flex space-x-2 items-center">
                        {mode === "view" ? (
                          <input
                            type="text"
                            className="w-full p-1 border border-gray-400 h-11"
                            placeholder="Enter cardno No"
                            value={formData.cardno}
                            onChange={(e) => handleChange("cardno", e.target.value)}
                            readOnly={mode === "view"}
                          />
                        ) : (
                          <>
                            <select
                              className="w-full my-1 border border-gray-400 h-11"
                              onChange={(ev) => handleChange("cardno", ev.target.value)}
                              value={formData.cardno}
                            >
                              <option value="">select card no</option>
                              {cardnolist.map((item, idx) => (
                                <option key={idx} value={item.cardNo}>
                                  {item.cardNo}
                                </option>
                              ))}
                            </select>
                            <button
                              type="button"
                              title="Scan card barcode"
                              onClick={openScanner}
                              className="shrink-0 p-2 h-11 rounded border border-gray-400 bg-white hover:bg-teal-50 text-teal-700"
                            >
                              <FaCamera className="w-4 h-4" />
                            </button>
                          </>
                        )}

                        <input
                          type="text"
                          className="w-full p-1 border border-gray-400 h-11"
                          placeholder="Batch No"
                          value={formData.lotno}
                          onChange={(e) => handleChange("lotno", e.target.value)}
                          readOnly={mode === "view"}
                        />
                      </div>
                    </td>

                  </tr>
                </tbody>
              </table>
            </div>

            {/* Right Table */}
            <div className="flex-1">
              <table className="w-full border-collapse border border-black">
                {/* Header Row */}
                <thead className="">
                  <tr className="bg-gray-200">
                    {/* "Consumer Inspection Report" spanning two rows and two columns */}
                    <th rowSpan={2} colSpan={2} className="border border-black text-center text-lg font-semibold p-7">
                      Consumer's Inspection Report
                    </th>
                    <th colSpan={2} className="border border-black p-1">Report No {formData.reportno}</th>
                  </tr>
                  <tr className="bg-gray-200">
                    <th colSpan={2} className="border border-black p-1">Date : {String(new Date().getDate()).padStart(2, '0')}-{String(new Date().getMonth() + 1).padStart(2, '0')}-{new Date().getFullYear()} </th>
                  </tr>
                </thead>

                <tbody>
                  {/* Second Row with 4 Columns */}
                  <tr className="bg-gray-100">
                    <th className="border border-black p-2 h-16">Qty No</th>
                    <th className="border border-black p-2 h-16">O.K.</th>
                    <th className="border border-black p-2 h-16">Rework</th>
                    <th className="border border-black p-2 h-16">Reject</th>
                  </tr>

                  {/* Third Row with Inputs */}
                  <tr>
                    <td className="border border-black p-2">
                      <input
                        type="text"
                        className="w-full p-1 border border-gray-400 h-11"
                        value={formData.qtyno}
                        onChange={(e) => handleChange("qtyno", e.target.value)}
                        readOnly={mode == "view"}

                      />
                    </td>
                    <td className="border border-black p-1">
                      {/* <p className="mb-2">readOnly={mode == "view"}</p> */}
                      <input type="text" className="w-full p-1 border border-gray-400 h-11"
                        readOnly={mode == "view"}
                      />
                    </td>
                    <td className="border border-black p-1">
                      <input
                        type="text"
                        className="w-full p-1 border border-gray-400 h-11"
                        value={formData.rework}
                        onChange={(e) => handleChange("rework", e.target.value)}
                        readOnly={mode == "view"}

                      />
                    </td>
                    <input
                      type="text"
                      className="w-full p-1 border border-gray-400 h-11"
                      value={formData.reject}
                      onChange={(e) => handleChange("reject", e.target.value)}
                      readOnly={mode == "view"}

                    />
                  </tr>


                  {/* Fourth Row with Two Columns */}
                  <tr className="bg-gray-100">
                    <th className="border border-black p-2 h-16" colSpan={2}>
                      MTC Report No
                    </th>
                    <th className="border border-black p-2 h-16" colSpan={2}>
                      Lot No
                    </th>
                  </tr>

                  {/* Fifth Row with Inputs */}
                  <tr>
                    <td className="border border-black p-2" colSpan={2}>
                      <input
                        type="text"
                        className="w-full p-1 border border-gray-400 h-11"
                        value={formData.mtcreportno}
                        onChange={(e) => handleChange("mtcreportno", e.target.value)}
                        readOnly={mode == "view"}
                      />
                    </td>
                    <td className="border border-black p-2" colSpan={2}>
                      <input
                        type="text"
                        className="w-full p-1 border border-gray-400 h-11"
                        value={formData.batchno}
                        onChange={(e) => handleChange("batchno", e.target.value)}
                        readOnly={mode == "view"}

                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          {/* body  */}
          <table className="w-full mt-4 border-collapse border text-sm overflow-x-scroll grid">
            <thead>
              <tr className="bg-gray-200">
                <th className="border p-2" rowSpan={2}>S.NO.</th>
                <th className="border p-2" rowSpan={2}>Description</th>
                <th className="border p-2" rowSpan={2}>Specified Dimensions</th>
                <th className="border p-2" colSpan={5}>Observed Dimensions</th>
                <th className="border p-2" rowSpan={2}>Measuring Instruments</th>
                <th className="border p-2" rowSpan={2}>Remarks</th>
              </tr>
              <tr>
                <th className="border p-2">Sample 1</th>
                <th className="border p-2">Sample 2</th>
                <th className="border p-2">Sample 3</th>
                <th className="border p-2">Sample 4</th>
                <th className="border p-2">Sample 5</th>
              </tr>
            </thead>
            <tbody>
              {formData.table.map((row, rowIndex) => (
                <tr key={row.id}>
                  <td className="border p-2">{rowIndex + 1}</td>
                  <td className="border p-2 w-36">
                    <input
                      type="text"
                      className="w-full p-1 border h-11"
                      value={row.description}
                      onChange={(e) => handleTableChange(row.id, "description", e.target.value)}
                      readOnly={mode == "view"}

                    />
                  </td>
                  <td className="border p-2">
                    <input
                      type="text"
                      className="w-full p-1 border h-11"
                      value={row.specifiedDimensions}
                      data-row={rowIndex}
                      data-col={-1}
                      onKeyDown={handleArrowKeyNavigation}
                      onChange={(e) => handleTableChange(row.id, "specifiedDimensions", e.target.value)}
                      readOnly={mode == "view"}
                    />
                  </td>

                  {row.observedDimensions.map((sample, sampleIndex) => (
                    <td className="border p-2">
                      <input
                        key={sampleIndex}
                        data-row={rowIndex}
                        data-col={sampleIndex}
                        type="text"
                        className="w-full p-1 border mb-1 h-11"
                        value={sample}
                        onChange={(e) => handleTableChange(row.id, "observedDimensions", e.target.value, sampleIndex)}
                        onKeyDown={handleArrowKeyNavigation}
                        readOnly={mode == "view"}

                      />
                    </td>
                  ))}

                  <td className="border p-2">
                    <input
                      type="text"
                      className="w-full p-1 border h-11"
                      value={row.measuringInstruments}
                      data-row={rowIndex}
                      data-col={5}
                      onKeyDown={handleArrowKeyNavigation}
                      onChange={(e) => handleTableChange(row.id, "measuringInstruments", e.target.value)}
                      readOnly={mode == "view"}
                    />
                  </td>
                  <td className="border p-2">
                    <input
                      type="text"
                      className="w-full p-1 border h-11"
                      value={row.remarks}
                      data-row={rowIndex}
                      data-col={6}
                      onKeyDown={handleArrowKeyNavigation}
                      onChange={(e) => handleTableChange(row.id, "remarks", e.target.value)}
                      readOnly={mode == "view"}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>


          <div className="mt-4 text-sm">
            <div className="text-xl font-semibold text-center ">REJECTED PARAMETERS </div>
            <div className="flex flex-col  mt-2">
              <div className="flex items-center space-x-2 mx-2">
                <span className=" font-semibold text-md">Dimension:</span>
                <label>
                  <input
                    type="radio"
                    name="dimension"
                    value="OK"
                    checked={formData.dimension === "OK"}
                    onChange={(e) => handleChange("dimension", e.target.value)}
                    disabled={mode == "view"}


                  />
                  OK
                </label>
                <label>
                  <input
                    type="radio"
                    name="dimension"
                    value="NOT OK"
                    checked={formData.dimension !== "OK"}
                    onChange={(e) => handleChange("dimension", e.target.value)}
                    disabled={mode == "view"}


                  />
                  NOT OK
                </label>
              </div>
              <div className="flex items-center space-x-2 mx-2 mt-3 ">
                <span className="font-semibold text-md mr-3  ">Material: </span>
                <label>
                  <input
                    type="radio"
                    name="material"
                    value="OK"
                    checked={formData.material === "OK"}
                    onChange={(e) => handleChange("material", e.target.value)}
                    disabled={mode == "view"}
                  />
                  OK
                </label>
                <label>
                  <input
                    type="radio"
                    name="material"
                    value="NOT OK"
                    checked={formData.material !== "OK"}
                    onChange={(e) => handleChange("material", e.target.value)}
                    disabled={mode == "view"}

                  />{" "}
                  NOT OK
                </label>
              </div>
            </div>
          </div>

          <div className="overflow-x-auto p-4">
            <table className="w-full border-collapse border border-gray-300">
              <thead>
                <tr className="bg-gray-100">
                  <th colSpan={2} className="border border-gray-300 p-2 text-center">Inspection By</th>
                  <th colSpan={2} className="border border-gray-300 p-2 text-center">Verified By</th>
                </tr>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 p-2">Signature</th>
                  <th className="border border-gray-300 p-2">Date</th>
                  <th className="border border-gray-300 p-2">Signature</th>
                  <th className="border border-gray-300 p-2">Date</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-300 p-4 h-16"></td>
                  <td className="border border-gray-300 p-4 h-16"></td>
                  <td className="border border-gray-300 p-4 h-16"></td>
                  <td className="border border-gray-300 p-4 h-16"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>


        <div className="flex justify-center place-content-center align-middle items-center m-5">
          <button className="bg-blue-400 py-2 px-4 rounded-lg " onClick={handleSubmit}>
            {mode === "update"
              ? "Update"
              : mode === "new" ? "Submit"
                : mode === "view"
                  ? "Download PDF"
                  : "Submit"}
          </button>
        </div>
      </div>

      {showScanner && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 p-3">
          <div className="bg-white rounded-md shadow-lg w-full max-w-md overflow-hidden">
            <div className="flex items-center justify-between px-3 py-2 border-b bg-teal-700 text-white">
              <h3 className="text-sm font-semibold">Scan Card No. Barcode</h3>
              <button
                type="button"
                onClick={closeScanner}
                className="p-1 rounded hover:bg-teal-600"
                title="Close"
              >
                <FaTimes className="w-3.5 h-3.5" />
              </button>
            </div>
            <div className="p-3">
              <p className="text-xs text-gray-600 mb-2">
                Point the camera at the Card No. barcode on the order PDF.
              </p>
              <div
                id="fdi-card-barcode-reader"
                className="w-full overflow-hidden rounded border border-gray-300 bg-black min-h-[240px]"
              />
              {isScanning && (
                <p className="text-xs text-center text-teal-700 mt-2">
                  Scanning…
                </p>
              )}
              <button
                type="button"
                onClick={closeScanner}
                className="mt-3 w-full py-1.5 text-xs bg-gray-200 hover:bg-gray-300 rounded"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Fdiform;